import {
  ColumnFiltersState,
  getFilteredRowModel,
  getPaginationRowModel,
  OnChangeFn,
  PaginationState,
} from "@tanstack/react-table"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { useColumns } from "~/pages/Brand/Suppliers/List/SupplierRisk/columns.tsx"

interface Props {
  suppliersData: LibraryResponses.SupplierRiskResponse
  pagination: PaginationState
  setPagination: OnChangeFn<PaginationState>
}

export const SuppliersRisk = ({
  suppliersData,
  pagination,
  setPagination,
}: Props) => {
  const [pageCount, setPageCount] = useState(1)
  const { count, suppliers } = suppliersData
  const [searchParams] = useSearchParams()
  const urlSearch = searchParams.get("search")
  const [search, setSearch] = useState(urlSearch ?? "")
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  useEffect(() => {
    setPageCount(Math.ceil(count / DEFAULT_PAGE_SIZE))
  }, [count])
  const columns = useColumns()
  const table = useCustomReactTable({
    data: suppliers,
    columns,
    initialState: {
      pagination: {
        pageIndex: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    },
    state: {
      globalFilter: search,
      columnFilters,
      pagination,
    },
    pageCount,
    manualPagination: true,
    onPaginationChange: setPagination,
    onGlobalFilterChange: setSearch,

    onColumnFiltersChange: setColumnFilters,

    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  })
  return (
    <CustomTable
      table={table}
      pagination={true}
      manualPaginationCount={count}
    />
  )
}
